

import { ICallbacksSaga } from "@interfaces/saga";
import ActionType from "./action-type";


export function fetchImage( params: any, callbacks: ICallbacksSaga) {
  return {
    type: ActionType.FETCH_IMAGE,
    params,
    callbacks,
  };
}

export function saveImage(formData: any, callbacks?: ICallbacksSaga, onUploadProgress?:Function) {
  return {
    type: ActionType.SAVE_IMAGE,
    formData,
    callbacks,
    onUploadProgress
  }
}

export function uploadImage(formData: FormData, callbacks?: ICallbacksSaga, onUploadProgress?:Function) {
  return {
    type: ActionType.UPLOAD_IMAGE,
    formData,
    callbacks,
    onUploadProgress
  }
}

export function deleteImage(id: any, callbacks?: ICallbacksSaga) {
  return {
    type: ActionType.DELETE_IMAGE,
    id,
    callbacks,
  }
}

export function fetchBusinessImages(businessId: string, params: any, callbacks: ICallbacksSaga) {
  return {
    type: ActionType.FETCH_BUSINESS_IMAGES,
    businessId,
    params,
    callbacks,
  };
}

export function uploadPublicImage(formData: FormData, callbacks: ICallbacksSaga, onUploadProgress: Function, businessId: string) {
  return {
    type: ActionType.UPLOAD_PUBLIC_IMAGE,
    formData,
    callbacks,
    onUploadProgress,
    businessId,
  };
}

export function deleteMultipleFiles(imageIds: string[], businessId: string, callbacks: ICallbacksSaga) {
  return {
    type: ActionType.DELETE_MULTIPLE_FILES,
    imageIds,
    businessId,
    callbacks,
  };
}

export function setMediaData(data: any) {
  return {
    type: ActionType.SET_MEDIA_DATA,
    data,
  };
}

